<template>
    <b-row class="slide-body">          
            
        <b-row align-h="center" class="pb-3"><h1 style="color:#ffffff">{{ $t('slide23.text4') }}</h1></b-row>

        <b-row align-h="center">
            <b-col cols="4"> 
                <b-alert show variant="light"><h5><strong>{{ $t('slide23.text5') }}</strong></h5></b-alert> 
            </b-col>
            <b-col cols="2"> 
                <b-form-group>
                    <b-form-radio-group id="slide23EndDesign1" name="slide23EndDesign1" v-model="slide23EndDesign1">
                        <b-form-radio value="true">Sí</b-form-radio>
                        <b-form-radio value="false" >No</b-form-radio>                
                    </b-form-radio-group>
                </b-form-group>                        
            </b-col>
            <b-col cols="4"> 
                <b-alert show variant="light"><h5><strong>{{ $t('slide23.text6') }}</strong></h5></b-alert>   
            </b-col>
            <b-col cols="2"> 
                <b-form-group>                            
                    <b-form-radio-group id="slide23EndDesign2" name="slide23EndDesign2" v-model="slide23EndDesign2">
                        <b-form-radio value="true" >Sí</b-form-radio>
                        <b-form-radio value="false">No</b-form-radio>                
                    </b-form-radio-group>
                </b-form-group>
            </b-col>
        </b-row>               

        <b-row align-h="center">
            <b-col cols="4"> 
                <b-alert show variant="light"><h5><strong>{{ $t('slide23.text7') }}</strong></h5></b-alert>   
            </b-col>
            <b-col cols="2"> 
                    <b-form-group>                            
                    <b-form-radio-group name="slide23EndDesign3" v-model="slide23EndDesign3">
                        <b-form-radio value="true" >Sí</b-form-radio>
                        <b-form-radio value="false" >No</b-form-radio>                
                    </b-form-radio-group>
                </b-form-group>
            </b-col>               
            <b-col cols="4"> 
                <b-alert show variant="light"><h5><strong>{{ $t('slide23.text8') }}</strong></h5></b-alert>   
            </b-col>
            <b-col cols="2"> 
                <b-form-group>                            
                    <b-form-radio-group  name="slide23EndDesign4" v-model="slide23EndDesign4">
                        <b-form-radio value="true" >Sí</b-form-radio>
                        <b-form-radio value="false">No</b-form-radio>                
                    </b-form-radio-group>
                </b-form-group>
            </b-col>
        </b-row>

        <b-row align-h="center">
            <b-col cols="4"> 
                <b-alert show variant="light"><h5><strong>{{ $t('slide23.text9') }}</strong></h5></b-alert>   
            </b-col>
            <b-col cols="2"> 
                <b-form-group>                            
                    <b-form-radio-group name="slide23EndDesign5" v-model="slide23EndDesign5">
                        <b-form-radio value="true">Sí</b-form-radio>
                        <b-form-radio value="false" >No</b-form-radio>                
                    </b-form-radio-group>
                </b-form-group>
            </b-col>             
            <b-col cols="4"> 
                <b-alert show variant="light"><h5><strong>{{ $t('slide23.text10') }}</strong></h5></b-alert>   
            </b-col>
            <b-col cols="2"> 
                <b-form-group> 
                    <b-form-input size="lg" class="text-center" :value="slide23EndDesign6" @input="updateVariable($event,'slide23EndDesign6')" ></b-form-input>
                </b-form-group>
            </b-col>
        </b-row>

        <b-row align-h="center">
            <b-col cols="4"> 
                <b-alert show variant="light"><h5><strong>{{ $t('slide23.text11') }}</strong></h5></b-alert>   
            </b-col>
            <b-col cols="2"> 
                <b-form-group>                            
                    <b-form-input size="lg" class="text-center" :value="slide23EndDesign7" @input="updateVariable($event,'slide23EndDesign7')" ></b-form-input>
                </b-form-group>
            </b-col>               
            <b-col cols="4"> 
                <b-alert show variant="light"><h5><strong>{{ $t('slide23.text12') }}</strong></h5></b-alert>   
            </b-col>
            <b-col cols="2"> 
                <b-form-group>                            
                    <b-form-input size="lg" class="text-center" :value="slide23EndDesign8" @input="updateVariable($event,'slide23EndDesign8')" ></b-form-input>
                </b-form-group>
            </b-col>
        </b-row>

        <b-row >
            <b-col cols="4"> 
                <b-alert show variant="light"><h5><strong>{{ $t('slide23.text13') }}</strong></h5></b-alert>   
            </b-col>
            <b-col cols="2"> 
                <b-form-group>                            
                    <b-form-input size="lg" class="text-center" :value="slide23EndDesign9" @input="updateVariable($event,'slide23EndDesign9')" ></b-form-input>
                </b-form-group>
            </b-col>
            <b-col cols="6">
                <b-button @click="fSendAnswer" variant="success"><h2><strong>{{ $t('slide23.text14') }}</strong></h2></b-button>
                <b-modal v-model="modalSendAnswerShow" ok-only ok-variant="secondary" :title="$t('slide23.text15')" 
                effect="fade/zoom" :ok-title="$t('slide23.text17')">
                    <form role="form" method="post">
                        <div class="form-group"> 
                            <label><p>{{ $t('slide23.text16') }}</p></label>                                                       
                        </div>
                    </form>
                </b-modal>

            </b-col>
        </b-row>                         
                    
    </b-row>          
</template>

<script>
import {mapState} from 'vuex';

export default {    
     props:['lang'],
    data(){
        return {
            modalSendAnswerShow: false,           
        }
    },
    computed: {
        ...mapState(['showMenu','slide23EndDesign6','slide23EndDesign7','slide23EndDesign8','slide23EndDesign9',
        'elapsedTimeGame2','PuntsJoc1']),
        slide23EndDesign1:{
            set(value){
                this.$store.dispatch('updateVariable',{name: 'slide23EndDesign1',value: value});
            },
            get(){
                return this.$store.state.slide23EndDesign1;
            }
        },
        slide23EndDesign2:{
            set(value){
                this.$store.dispatch('updateVariable',{name: 'slide23EndDesign2',value: value});
            },
            get(){
                return this.$store.state.slide23EndDesign2;
            }
        },
        slide23EndDesign3:{
            set(value){
                this.$store.dispatch('updateVariable',{name: 'slide23EndDesign3',value: value});
            },
            get(){
                return this.$store.state.slide23EndDesign3;
            }
        },
        slide23EndDesign4:{
            set(value){
                this.$store.dispatch('updateVariable',{name: 'slide23EndDesign4',value: value});
            },
            get(){
                return this.$store.state.slide23EndDesign4;
            }
        },
        slide23EndDesign5:{
            set(value){
                this.$store.dispatch('updateVariable',{name: 'slide23EndDesign5',value: value});
            },
            get(){
                return this.$store.state.slide23EndDesign5;
            }
        },
    },
    methods:{
        isNumber(n){
            return /^-?[\d.]+(?:e-?\d+)?$/.test(n); 
        },
        updateVariable(event, varName){
            this.$store.dispatch('updateVariable',{name: varName,value: event});
        },
        fSendAnswer(){
            var PuntsJoc2=0;
            var valorReptes=30;
            var punts = 100;
            var tempsRestantsJocs2 = 0;
            var timerSeconds = 600;
            var puntsTotals = 0;            

            //Comprovar que totes les respostes estan completades
            if(this.slide23EndDesign1==null || this.slide23EndDesign2==null || this.slide23EndDesign3==null || this.slide23EndDesign4==null || 
                this.slide23EndDesign5==null ){
                    this.modalSendAnswerShow=true;
            }else if(this.slide23EndDesign6.trim()=="" || this.slide23EndDesign7.trim()=="" || this.slide23EndDesign8.trim()=="" || this.slide23EndDesign9.trim()==""){
                    this.modalSendAnswerShow=true;
            }else{

                if(this.slide23EndDesign1==true){
                    PuntsJoc2 = PuntsJoc2 + valorReptes * 3;
                }

                if(this.slide23EndDesign2==true){
                    PuntsJoc2 = PuntsJoc2 + valorReptes;
                }

                if(this.slide23EndDesign3==true){
                    PuntsJoc2 = PuntsJoc2 + valorReptes;
                }

                if(this.slide23EndDesign4==true){
                    PuntsJoc2 = PuntsJoc2 + valorReptes;
                }

                if(this.slide23EndDesign5==true){
                    PuntsJoc2 = PuntsJoc2 + valorReptes;
                }

                if(this.slide23EndDesign6.trim()>"0"){
                    if(this.isNumber(this.slide23EndDesign6) && this.slide23EndDesign6.trim()<=100)
                    {
                        PuntsJoc2 = PuntsJoc2 + (100 - this.slide23EndDesign6.trim())*5;
                    }
                }

                if(this.slide23EndDesign7.trim()=="3"){
                    PuntsJoc2 = PuntsJoc2 + valorReptes;
                }

                if(this.slide23EndDesign8.trim()=="2"){
                    PuntsJoc2 = PuntsJoc2 + valorReptes;
                }

                if(this.slide23EndDesign9.trim()=="2"){
                    PuntsJoc2 = PuntsJoc2 + valorReptes;
                }
        
                tempsRestantsJocs2 = timerSeconds - this.elapsedTimeGame2;
                
                PuntsJoc2 = PuntsJoc2 + tempsRestantsJocs2 / 10;
               
            
                puntsTotals = parseInt(punts) + parseInt(this.PuntsJoc1) + parseInt(PuntsJoc2);
                puntsTotals = Math.round(puntsTotals);

                this.$store.dispatch('updateVariable',{name: 'PuntsJoc2',value: PuntsJoc2});                
                this.$store.dispatch('updateVariable',{name: 'puntsTotals',value: puntsTotals});
                this.$router.push("/slide24/"+this.lang);
            }
        }
    },
    beforeCreate(){
        this.$store.dispatch('changeShowMenu',true);
        
    },
    created(){
        this.$i18n.locale=this.lang;
    }    
      
}
</script>


<style scoped>

    .row{
        margin-left: 0px;
        margin-right: 0px;  
        position:relative; 
        width: 100%; 
    }    

</style>